<script setup lang="ts">
import BrokerApplicationLayout from '@/layouts/BrokerApplicationLayout.vue';
import UserQuoteLayout from '@/layouts/UserQuoteLayout.vue';
import CustomerApplicationLayout from '@/layouts/CustomerApplicationLayout.vue';
import DeclarationLayout from '@/layouts/DeclarationLayout.vue';
import EmptyLayout from '@/layouts/EmptyLayout.vue';
import RequestIncomeExpenseLayout from '@/layouts/RequestIncomeExpenseLayout.vue';
import DischargeRequestLayout from '@/layouts/DischargeRequestLayout.vue';
import CustomerQuoteLayout from '@/layouts/CustomerQuoteLayout.vue';
import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const layout = computed(() => {
  const layout = route.meta.layout;
  switch (layout) {
    case 'EmptyLayout':
      return EmptyLayout;
    case 'BrokerApplicationLayout':
      return BrokerApplicationLayout;
    case 'UserQuoteLayout':
      return UserQuoteLayout;
    case 'DeclarationLayout':
      return DeclarationLayout;
    case 'RequestIncomeExpenseLayout':
      return RequestIncomeExpenseLayout;
    case 'DischargeRequestLayout':
      return DischargeRequestLayout;
    case 'CustomerQuoteLayout':
      return CustomerQuoteLayout;
    default:
      return CustomerApplicationLayout;
  }
});

onMounted(() => {
  const link = document?.querySelector("link[rel~='icon']") as unknown as { href: string };
  const customIcon = import.meta.env?.VITE_APP_CUSTOM_THEME_ICON;
  if (link && customIcon) {
    link.href = customIcon;
  }
});
</script>

<template>
  <component :is="layout">
    <RouterView />
  </component>
</template>
